import React, { useCallback, createContext, useState, useEffect, useContext } from "react";
import dynamic from "next/dynamic";
import { usePopup } from "@/shared/hooks/usePopup";

const CustomContextMenuPopup = dynamic(() => import("@/components/Popup/CustomContextMenuPopup"), {
  ssr: false,
});

const RightClickMenuContext = createContext({});

export const ContextMenuProvider = ({ children }) => {
  const [fnGetUrl, setFnGetUrl] = useState(null);
  const { isShown, anchorEl, openPopup, closePopup } = usePopup();

  const handleContextListener = useCallback((e) => {
    openPopup(e);
    const linkRelated = e.detail.target.tagName === "A"
      ? e.detail.target
      : e.detail.target.querySelector("a");

    if (typeof e.detail.getUrl === "function") {
      setFnGetUrl(e.detail.getUrl);
    } else if (linkRelated) {
      setFnGetUrl(() => linkRelated.href);
    } else {
      setFnGetUrl(null);
    }
  }, [openPopup]);

  useEffect(() => {
    document.addEventListener("contextMenuCustom", handleContextListener);
    return () => {
      document.addEventListener("contextMenuCustom", handleContextListener);
    };
  }, [handleContextListener, isShown]);

  useEffect(() => {
    if (!isShown) {
      setFnGetUrl(null);
    }
  }, [isShown]);

  return (
    <RightClickMenuContext.Provider value={{ fnGetUrl, anchorEl, isShown, closePopup }} >
      {children}
      <CustomContextMenuPopup />
    </RightClickMenuContext.Provider>
  );
};

export const useCustomMenuContext = () => useContext(RightClickMenuContext);

